import { RouteConfig } from 'vue-router';
import PView from '../layouts/view.vue';
const emailRoute: RouteConfig[] = [
  {
    path: '/email.html',
    meta: { title: '联系人' },
    component: PView,
    children: [
      {
        path: '/email.html',
        name: 'email',
        component: () => import('@/views/email/index.vue'),
        meta: {
          title: '龙艺秀_免费在线收款制作平台',
        },
      },
    ],
  },
  {
    path: '/sms',
    component: { render: (c) => c('router-view') },
    children: [
      {
        path: '/sms/sendSmsRecord.html',
        name: 'sendSmsRecord',
        component: () => import('@/views/email/sms/sendSmsRecord.vue'),
        meta: {
          title: '龙艺秀_免费在线收款制作平台_发送记录',
        },
      },
      {
        path: '/sms/sendSms.html',
        name: 'sendSms',
        component: () => import('@/views/email/sms/sendSms.vue'),
        meta: {
          title: '龙艺秀_免费在线收款制作平台_发送短信',
        },
      },
      {
        path: '/sms/recordDetail.html',
        name: 'recordDetail',
        component: () => import('@/views/email/sms/recordDetail.vue'),
        meta: {
          title: '龙艺秀_免费在线收款制作平台_查看详情',
        },
      },
    ],
  },
  {
    path: '/mail',
    component: { render: (c) => c('router-view') },
    children: [
      {
        path: '/mail/sendMail.html',
        name: 'sendMail',
        component: () => import('@/views/email/mail/sendMail.vue'),
        meta: {
          title: '龙艺秀_免费在线收款制作平台_发送邮件',
        },
      },
    ],
  },
];
export { emailRoute };
